import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { curdActions } from "../../../reduxCURD/actions";
import _ from "lodash";
import "./styles.css";
import { Icon } from "react-icons-kit";
import { software_pen } from "react-icons-kit/linea/software_pen";
import {
  arrayToTree,
  filterTreeByProperties,
  loadTreeObjects,
  TreeNode,
  findTreeNode,
  groupTreeNodeByProperty,
  treeToArray,
  treeToPropertiesObject,
  oneLayerTreeItemsToObjects,
} from "../../../utils/treeData";
import { CRUDFunction } from "../../../reduxCURD/container";
import { MyButton } from "../../Common/Forms/formsMiscItems";

import { updateAssetLocation } from "../../../reduxRelated/actions/assetHelperAction";

class MoveAssets extends Component {
  constructor(props) {
    super(props);

    this.state = {
      plannableLocations: null,
      searchStr: "",
      selectedAsset: null,
      selectedLocation: null,
      updateDetails: {
        updateLocation: null,
        newStart: null,
        newEnd: null,
      },

      assetGroupByLocation: [],
      assets: null,
      assetList: null,
    };

    this.setSelectedAsset = this.setSelectedAsset.bind(this);
    this.setupdateDetails = this.setupdateDetails.bind(this);
    this.moveAssetLocation = this.moveAssetLocation.bind(this);
  }

  componentDidMount() {
    console.log("mount");
    this.props.getAssets("/getAssetTree");
  }

  componentDidUpdate(prevProps) {
    if (this.props.assetActionType === "ASSETS_READ_SUCCESS" && this.props.assetActionType !== prevProps.assetActionType) {
      let assetTree = this.props.assets.assetsTreeObj;
      let assetList = treeToPropertiesObject(assetTree);
      let plannableLocations = this.findPlannableLocations(assetTree, assetList);
      let locationGroup = this.groupByLocation(assetTree, plannableLocations);
      this.setState({
        assetTree: assetTree,
        spinnerLoading: false,
        plannableLocations: plannableLocations,
        assetGroupByLocation: locationGroup,
        assetList: assetList,
      });
    }

    if (this.props.assetActionType === "ASSET_UPDATE_REQUEST" && this.props.assetActionType !== prevProps.assetActionType) {
      console.log("update");
    }

    if (this.props.assetActionType === "ASSET_UPDATE_FAILURE" && this.props.assetActionType !== prevProps.assetActionType) {
      console.log("update");
    }

    if (
      this.props.assetHelperActionType === "MOVE_ASSET_LOCATION_SUCCESS" &&
      this.props.assetHelperActionType !== prevProps.assetHelperActionType
    ) {
      this.props.getAssets("/getAssetTree");
      this.setState({
        selectedAsset: null,
        selectedLocation: null,
        updateDetails: {
          updateLocation: null,
          newStart: null,
          newEnd: null,
        },
      });
    }
  }

  moveAssetLocation() {
    const selectedAsset = this.state.selectedAsset;
    const updateDetails = this.state.updateDetails;
    const selectedLocation = this.state.selectedLocation;
    const data = {
      assetToUpdate: null,
      assetChildren: null,
      locationInfo: null,
    };

    data.assetToUpdate = {
      _id: selectedAsset._id,
      oldStart: selectedAsset.start,
      oldEnd: selectedAsset.end,
      newStart: updateDetails.newStart,
      newEnd: updateDetails.newEnd,
    };

    data.assetChildren = selectedAsset.children;

    data.locationInfo = updateDetails.updateLocation;

    let assetObj = JSON.stringify({
      assetToUpdate: data.assetToUpdate,
      assetChildren: data.assetChildren,
      locationInfo: data.locationInfo,
    });
    // this.props.updateAsset(null, "moveAsset/" + assetObj);

    this.props.updateAssetLocation(data);
  }

  setSelectedAsset(asset) {
    
    let selectedLocation = this.state.plannableLocations.find((p) => p._id === asset.locationId);
    let selectedAsset = this.state.assetList.find((a) => a._id === asset._id);
    this.setState({
      selectedAsset: {
        ...selectedAsset,
        children: asset.children.map((c) => c._id),
      },
      selectedLocation: selectedLocation,
      updateDetails: {
        updateLocation: null,
        newStart: null,
        newEnd: null,
      },
        });
  }

  setupdateDetails(e) {
    let { value, id } = e.target;
    if (id === "start") {
      this.setState({
        updateDetails: {
          ...this.state.updateDetails,
          newStart: value,
        },
      });
    } else if (id === "end") {
      this.setState({
        updateDetails: {
          ...this.state.updateDetails,
          newEnd: value,
        },
      });
    } else {
      let updateLocation = this.state.plannableLocations.find((p) => p._id === e.target.value);
      this.setState({
        updateDetails: {
          ...this.state.updateDetails,
          updateLocation: updateLocation,
        },
      });
    }
  }

  groupByLocation(asset, plannableLocations) {
    let locationGroup = [];

    let assetTree = asset;
    plannableLocations.forEach((loc) => {
      let LocationNode = findTreeNode(assetTree, loc._id);

      locationGroup.push(oneLayerTreeItemsToObjects(LocationNode));
    });

    locationGroup = locationGroup.flat();

    let locationAndChildGroup = locationGroup.map((asset) => {
      let assetNode = findTreeNode(assetTree, asset._id);
      let childArray = oneLayerTreeItemsToObjects(assetNode);

      return {
        ...asset,
        children: childArray,
      };
    });

    return locationAndChildGroup;
  }

  findPlannableLocations(assetTree, assetsList) {
    let locationsId = [];

    filterTreeByProperties(assetTree, { location: true, plannable: true }, locationsId);
    let plannableLocations = [];
    assetsList.forEach((asset) => {
      {
        let foundLocation = locationsId.find((l) => l === asset._id);
        foundLocation && plannableLocations.push(asset);
      }
    });

    return plannableLocations;
  }

  render() {
    const { searchStr } = this.state;
    const lowerCaseSearchStr = searchStr.toLowerCase();
    const filteredAssets = this.state.assetGroupByLocation
      ? this.state.assetGroupByLocation.filter((asset) => !searchStr || asset.unitId.toLowerCase().includes(lowerCaseSearchStr))
      : [];

    let selectedAsset = this.state.selectedAsset;
    let selectedLocation = this.state.selectedLocation;
    return (
      <div style={{width:"100%",padding: "10px"}}>
        <Col>
          <input value={searchStr} placeholder={`Search`} onChange={(e) => this.setState({ searchStr: e.target.value })} />
          <span style={{ padding: "0 10px" }}>{`Found ${filteredAssets.length} records`}</span>
        </Col>

        <div className="moveAsset-main">
          <div className="asset-Area">
            <Col >
              <RenderAssets setSelectedAsset={this.setSelectedAsset} assets={filteredAssets.length !== 0 ? filteredAssets : []} />
            </Col>
          </div>

          {selectedAsset && (
            <div className="assetInfo-area">
              <h3 style={{textAlign:"center",marginBottom:"0px" , backgroundColor:"var(--first)" ,padding:"5px 5px 5px 5px", border:"1px solid black"}}className="boldText">Update Asset </h3>

              <RenderUpdateDetails
                plannableLocations={this.state.plannableLocations}
                setupdateDetails={this.setupdateDetails}
                updateDetails={this.state.updateDetails}
                selectedAsset={selectedAsset}
                moveAssetLocation={this.moveAssetLocation}
                selectedLocation={selectedLocation}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

const RenderAssets = (props) => {
  return (
    props.assets.length !== 0 && (
      <table style={{width:"100%"}}>
        <thead>
          <tr>
            <th>Name</th>
            <th>Location</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {props.assets.map((asset) => {
            return (
              <tr>
                <td>{asset.unitId}</td>

                <td>{asset.locationName}</td>
                <td>
                  <button onClick={() => props.setSelectedAsset(asset)}> Edit </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    )
  );
};

const RenderUpdateDetails = ({
  plannableLocations,
  updateDetails,
  setupdateDetails,
  selectedAsset,
  moveAssetLocation,
  selectedLocation,
}) => {
  plannableLocations = plannableLocations.filter((p) => p._id !== selectedLocation._id);
  return (
    <div className="assetInfo-area-details">
      <div className="feild-area-select">
        <strong>Location:</strong>
        <label>{selectedLocation.unitId}</label>
      </div>

      <div className="feild-area">
        <strong>Location Start:</strong>
        <label>{selectedLocation.start}</label>
      </div>

      <div className="feild-area">
        <strong>Location End:</strong>
        <label>{selectedLocation.end}</label>
      </div>

      <div className="feild-area-select">
        <strong>Asset:</strong>
        <label>{selectedAsset.unitId}</label>
      </div>

      <div className="feild-area">
        <strong>Asset Start:</strong>
        <label>{selectedAsset.start}</label>
      </div>

      <div className="feild-area">
        <strong>Asset End:</strong>
        <label>{selectedAsset.end}</label>
      </div>

      <div className="feild-area-select">

         <strong>Select New Location: </strong> 
   
        <div >
          <select id="locationSelect" onChange={(e) => setupdateDetails(e)}>
            <option value="">Select a location</option>
            {plannableLocations.map((location) => (
              <option key={location._id} value={location._id}>
                {location.unitId}
              </option>
            ))}
          </select>
        </div>
      </div>

      {updateDetails && updateDetails.updateLocation && (
        <React.Fragment>
          <div className="feild-area-select">
            <strong>Asset New Location:</strong>
            <label>{updateDetails.updateLocation.unitId}</label>
          </div>
          <div className="feild-area">
            <strong>Location Start:</strong>
            <label>{updateDetails.updateLocation.start}</label>
          </div>

          <div className="feild-area">
            <strong>Location End:</strong>
            <label>{updateDetails.updateLocation.end}</label>
          </div>

          <div className="feild-area">
            <strong>Asset New Start:</strong>
            <input value={updateDetails.newStart} id="start" onChange={(e) => setupdateDetails(e)} className="input-style" />
          </div>

          <div className="feild-area">
            <strong>Asset New End:</strong>
            <input
              id="end"
              value={updateDetails.newEnd}
              onChange={(e) => {
                setupdateDetails(e);
              }}
              className="input-style"
            />
          </div>

          {selectedAsset.assetTypeClassify === "point" ? (
            <div className="feild-area-select">
              <strong>Note:</strong>
              <p><small>Only enter point values </small></p>
            </div>
          ) : (
            <p style={{width:"100%"}}> {" "}</p>
          )}
       </React.Fragment>
      )}

      {updateDetails && updateDetails.updateLocation && <button onClick={() => moveAssetLocation()}> Update Asset</button>}
    </div>
  );
};
const getAssets = curdActions.getAssets;
const getAssetType = curdActions.getAssetType;
const getAssetTests = curdActions.getAssetTests;
const getAssetTree = curdActions.getAssetTree;
const updateAsset = curdActions.updateAsset;
let variables = {
  assetReducer: { assets: [] },

  assetHelperReducer: {
    unassignedAssets: [],
  },
};

let actionOptions = {
  create: true,
  update: true,
  read: true,
  delete: true,
  others: {
    updateAssetLocation,
    getAssetType,
    getAssets,
    getAssetTests,
    getAssetTree,
    updateAsset,
  },
};
let containerReducers = ["assetReducer", "assetHelperReducer"];
let MoveAssetContainer = CRUDFunction(MoveAssets, "moveAssets", actionOptions, variables, containerReducers, "asset");
export default MoveAssetContainer;



// WEBPACK FOOTER //
// ./src/components/diagnostics/MoveAssets/MoveAssets.jsx